export const APPLIED_TAGS_GAP = 8;
export const APPLIED_TAG_HORIZONTAL_PADDING = 16;
export const APPLIED_TAG_ICON_WIDTH = 16;
export const APPLIED_TAG_ICON_GAP = 4;
export const EXACT_SEARCH_TOOLTIP_OFFSET: [number, number] = [0, 8];
